import { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { t, TranslationKey } from '@/lib/translations';

export function useTranslation() {
  const { currentLanguage } = useLanguage();
  const [, forceUpdate] = useState({});

  // Force component to re-render when language changes
  useEffect(() => {
    const handleLanguageChange = () => forceUpdate({});
    window.addEventListener('language-changed', handleLanguageChange);
    
    return () => {
      window.removeEventListener('language-changed', handleLanguageChange);
    };
  }, []);

  // Return the translation function
  const translate = (key: TranslationKey, params?: Record<string, string>) => {
    return t(key, params);
  };

  return { t: translate, language: currentLanguage };
}